import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { CreateOnAccessScanComponent } from './create-on-access-scan.component';

@NgModule({
    declarations: [CreateOnAccessScanComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CreateOnAccessScanModule { }
